module.exports = __webpack_public_path__ + "media/assets/images/flags/vn-2302b165bf84f6d4c10b60b42b3054ec.svg";